import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    padding: theme.spacing(0, 16),
    marginTop: '-6rem',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
      marginTop: '-4rem',
    },
  },

  topPostsWrapper: {
    background: '#F2F2F2',
  },
  topPosts: {
    backgroundImage: 'linear-gradient(180deg, white 20%, #F2F2F2 80%)',
  },
  notAloneWrapper: {
    padding: theme.spacing(10, 0, 30),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(12),
      padding: theme.spacing(10, 0, 23),
    },
  },
  opinionsWrapper: {
    paddingTop: '6rem',
    background: '#F2F2F2',
  },

  gradientBox: {
    height: '70px',
    background:
      'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 0.01%, #FFFFFF 100%)',
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '72px',
    textAlign: 'center',
    lineHeight: '82px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    padding: theme.spacing(0, 0, 12),
    [theme.breakpoints.down('md')]: {
      fontSize: '32px',
      textAlign: 'center',
      lineHeight: '44px',
    },
  },
  zenBg: {
    background: 'none',
  },
  impactCards: {
    paddingBottom: '6rem',
  },
}))

export default useStyles
